// extracted by mini-css-extract-plugin
module.exports = {"button-container":"ShareResult_button-container__3RVZf","alt-button":"ShareResult_alt-button__oiIzR","result":"ShareResult_result__KxJiD"};